import type { AxiosProgressEvent, AxiosRequestConfig } from 'axios'
import type { CustomOptions } from '@/types/axios'
import { filterConfig } from '@/utils/http/helper'
import '@/utils/http/axiosInterceptors'

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

axios.defaults.timeout = 120000
// axios.defaults.baseURL='http://tops.zlfund.cn'// 基本请求地址

// 自定义配置项 (_开头属性是自定义的配置)
const customConfig: CustomOptions = {
  _loading: false,
  _repeatRequestCancel: true,
  _repeatInputCancel: false,
  _requestRetry: false,
  _retryCount: 0, //
  _retryDelay: 1000,
  _errorMessageShow: true,
  _confirmMsg: false,
  _minLoadingDuration: 0
}

export async function aget(url: string, params = {}, config?: AxiosRequestConfig) {
  return new Promise((resolve: (value: any) => void, reject: (value: any) => void) => {
    const newConfig: AxiosRequestConfig = filterConfig(customConfig, config)
    axios
      .get(url, {
        params: params,
        ...newConfig,
        headers: { 'Content-Type': 'application/json' }
      })
      .then((response) => {
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export async function apost(url: string, data = {}, config?: AxiosRequestConfig) {
  return new Promise((resolve: (value: any) => void, reject: (value: any) => void) => {
    const newConfig: AxiosRequestConfig = filterConfig(customConfig, config)
    axios
      .post(url, data, {
        ...newConfig,
        headers: { 'Content-Type': 'application/json' }
      })
      .then(
        (response) => {
          resolve(response)
        },
        (err) => {
          reject(err)
        }
      )
  })
}

/**
 * 封装formdata的post请求
 * @param {*} url
 * @param {*} data
 * @param {*}  cb 回调函数
 * @returns {Promise}
 */
export async function aFormPost(
  url: string,
  data: any = {},
  config?: AxiosRequestConfig,
  cb?: (persent: number, loaded: number, total: number) => void
) {
  return new Promise((resolve: (value: any) => void, reject: (value: any) => void) => {
    // 转化为formdata
    const formData = new FormData()
    Object.keys(data).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        formData.append(key, data[key])
      }
    })
    const newConfig: AxiosRequestConfig = filterConfig(customConfig, config)
    axios
      .post(url, formData, {
        ...newConfig,
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent: AxiosProgressEvent) => {
          const persent = ((progressEvent.loaded / (progressEvent.total ? progressEvent.total : 0)) * 100) | 0
          if (cb) {
            cb(persent, progressEvent.loaded, progressEvent.total ? progressEvent.total : 0)
          }
        }
      })
      .then(
        (response) => {
          resolve(response)
        },
        (err) => {
          reject(err)
        }
      )
  })
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export async function adelete(url: string, params = {}, config?: AxiosRequestConfig) {
  return new Promise((resolve: (value: any) => void, reject: (value: any) => void) => {
    const newConfig: AxiosRequestConfig = filterConfig(customConfig, config)
    axios
      .delete(url, {
        params: params,
        ...newConfig,
        headers: { 'Content-Type': 'application/json' }
      })
      .then((response) => {
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
